<script>
  export let markNum1


  import { createEventDispatcher } from 'svelte';


	const dispatch = createEventDispatcher();

	function closeClick() {
		dispatch('message', {
      markNum1:1
    });
	}

// console.log(markNums);
</script>
<!-- markInfo_DRAIN -->
<div id="DRAIN" class={markNum1==0?"DRAIN":"DRAIN select"}>
  <slot></slot>
    <div id="close" class="close" on:click={closeClick}>
      <img id="closeBtn" src="./img/close.svg" alt=""  ><span>Schließen</span>
    </div>
</div>

<style>
  .DRAIN{
    width: auto;
    height: auto;
    background-color: #0089ca;
    border-radius: 13px;
    color: white;
    /*  原因出处：margin折叠； 加overflow：hidden的原因是由于子元素用到了margin来调整上下位置，但是该父元素并且没有设置border以及padding来限制，会出现margin-top无效 */
    overflow: hidden;
    display: none;
    position: absolute;
    top: 40px;
    left: 40px;
    z-index: 999;
    user-select: none;
 
  }
  .select{
    display: block;
  }

   img{
    vertical-align: middle;
    margin-right: 5px;
    width: 15px;
  }
   span{
    vertical-align: middle;
  }

  .close{
    padding-left: 22px;
    padding-bottom: 10px;
    font-size: 14px;
    user-select: none;
    cursor: pointer;
  }
</style>